import React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AddACLs from "./Add/AddACL";
import IndexPage from "../../../../Dashboard/Components/SecuritySettings/ACLs/Index";
import EditACLs from "./Edit/EditACL";
import "../../../../../Assets/Styles/ACLs.scss";
import DesktopOnlyOverlay from "../../../../Dashboard/Components/ShareElements/DesktopOnlyOverlay/DesktopOnlyOverlay";

const ACLsRoutes = (props) => {
  return (
    <BrowserRouter basename="/home/ACLs">
      <DesktopOnlyOverlay LangData={props.LangData} />
      <Switch>
        <Route path="/addACL">
          <AddACLs LangData={props.LangData} />
        </Route>
        <Route path="/editACL">
          <EditACLs LangData={props.LangData} />
        </Route>
        <Route path="/" exact>
          <IndexPage LangData={props.LangData} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
export default ACLsRoutes;
